import React from 'react';
import { MessageCircle, Check } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 bg-dark-100" data-id="element-14">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15">
        <div className="text-center mb-16" data-id="element-16">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-17">
            Tu Negocio Hace Un Trabajo Premium.{' '}
            <br className="hidden md:block" data-id="element-18" />
            <span className="text-gold" data-id="element-19">
              Es Hora De Que Tu Website Lo Demuestre.
            </span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-20">
            Empieza hoy con solo $125. Tu website profesional listo en menos de
            72 horas. Sin mensualidades obligatorias. Sin contratos. Sin
            complicaciones.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-21">
          {/* WhatsApp Card */}
          <div className="border border-[#25D366]/30 rounded-3xl p-8 md:p-10 text-center relative overflow-hidden" data-id="element-22">
            {/* Background image */}
            <img src="https://cdn.magicpatterns.com/uploads/f4TXKfANotJzXqWz17dwgk/heylloyd-image-1782678048806.png" alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover" data-id="element-23" />
            {/* Overlays for readability */}
            <div className="absolute inset-0 bg-dark/80" data-id="element-24"></div>
            <div className="absolute inset-0 bg-gradient-to-br from-[#25D366]/25 to-dark/90" data-id="element-25"></div>
            <div className="absolute top-0 right-0 w-32 h-32 bg-[#25D366]/10 rounded-full blur-3xl" data-id="element-26"></div>

            <div className="relative z-10" data-id="element-27">
              <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[#25D366] text-white mb-6 shadow-[0_0_30px_rgba(37,211,102,0.4)]" data-id="element-28">
                <MessageCircle className="w-10 h-10" data-id="element-29" />
              </div>

              <h3 className="text-2xl font-bold text-white mb-2" data-id="element-30">
                CONTÁCTANOS POR WHATSAPP AHORA
              </h3>

              <p className="text-gray-300 mb-8" data-id="element-31">
                Escríbenos "WEBSITE" y te respondemos hoy
              </p>

              <div className="space-y-3 text-left max-w-sm mx-auto mb-10" data-id="element-32">
                <div className="flex items-center gap-3" data-id="element-33">
                  <Check className="w-5 h-5 text-[#25D366]" data-id="element-34" />
                  <span className="text-white font-medium" data-id="element-35">
                    Respuesta rápida
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-36">
                  <Check className="w-5 h-5 text-[#25D366]" data-id="element-37" />
                  <span className="text-white font-medium" data-id="element-38">
                    Sin presión ni compromiso
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-39">
                  <Check className="w-5 h-5 text-[#25D366]" data-id="element-40" />
                  <span className="text-white font-medium" data-id="element-41">
                    Te explicamos todo en minutos
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-42">
                  <Check className="w-5 h-5 text-[#25D366]" data-id="element-43" />
                  <span className="text-white font-medium" data-id="element-44">
                    Empezamos cuando tú estés listo
                  </span>
                </div>
              </div>

              <a href="https://wa.me/447311754270?text=WEBSITE" target="_blank" rel="noopener noreferrer" className="block w-full py-4 px-8 bg-[#25D366] hover:bg-[#20bd5a] text-white font-bold rounded-full transition-all transform hover:scale-105 shadow-lg" data-id="element-45">
                ESCRIBIR POR WHATSAPP AHORA →
              </a>
            </div>
          </div>

          {/* Summary Card */}
          <div className="bg-dark rounded-3xl border border-white/10 p-8 md:p-10" data-id="element-46">
            <h3 className="text-xl font-bold text-white mb-8 text-center border-b border-white/10 pb-6" data-id="element-47">
              RESUMEN RÁPIDO DE LA OFERTA
            </h3>

            <div className="space-y-6" data-id="element-48">
              <div className="flex justify-between items-center pb-4 border-b border-white/5" data-id="element-49">
                <span className="text-gray-400" data-id="element-50">
                  Website profesional completo
                </span>
                <span className="text-white font-bold text-right" data-id="element-51">
                  $250 pago único
                </span>
              </div>
              <div className="flex justify-between items-center pb-4 border-b border-white/5" data-id="element-52">
                <span className="text-gray-400" data-id="element-53">Para empezar solo</span>
                <span className="text-gold font-bold text-right" data-id="element-54">
                  $125 (50% adelantado)
                </span>
              </div>
              <div className="flex justify-between items-center pb-4 border-b border-white/5" data-id="element-55">
                <span className="text-gray-400" data-id="element-56">Listo en</span>
                <span className="text-white font-bold text-right" data-id="element-57">
                  Menos de 72 horas
                </span>
              </div>
              <div className="flex justify-between items-center pb-4 border-b border-white/5" data-id="element-58">
                <span className="text-gray-400" data-id="element-59">
                  Mensualidades obligatorias
                </span>
                <span className="text-white font-bold text-right" data-id="element-60">
                  $0 — No hay
                </span>
              </div>
              <div className="flex justify-between items-center pb-4 border-b border-white/5" data-id="element-61">
                <span className="text-gray-400" data-id="element-62">Mantenimiento opcional</span>
                <span className="text-white font-bold text-right" data-id="element-63">
                  $30/mes si lo deseas
                </span>
              </div>
              <div className="flex justify-between items-center pb-4 border-b border-white/5" data-id="element-64">
                <span className="text-gray-400" data-id="element-65">Contrato largo</span>
                <span className="text-white font-bold text-right" data-id="element-66">
                  No existe
                </span>
              </div>
              <div className="flex justify-between items-center" data-id="element-67">
                <span className="text-gray-400" data-id="element-68">Sorpresas de precio</span>
                <span className="text-white font-bold text-right" data-id="element-69">
                  No existen
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}